/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

import IMask from "imask";
import * as yup from 'yup';
import { cloneDeep } from 'lodash';
import moment from "moment";

function handleInitialAdjustments({ questionnaire }) {
  return questionnaire.map(question => {
    return question;
  })
};

function handleSave({
  values,
  questionnaire,
  idOperation,
  idOperationParent,
  SECTIONS,
  mc,
  formikRef,
  refQuestionnaireSent,
  useGetQuestionnaireAnswerRequest,
  useSaveQuestionnaireAnswerRequest,
  submitFunction
}) {

  buildValidation({
    values,
    questionnaire,
    idOperation,
    idOperationParent,
    SECTIONS,
    refQuestionnaireSent,
  }).validate(values, { abortEarly: false }).then(() => {
     const isValidSubmittedForm = handleValidationsSubmittedForm({
      values,
      questionnaire,
      setFieldError: formikRef.current.setFieldError,
      SECTIONS,
      mc,
    });

    if (isValidSubmittedForm) {
      handleSubmit({
        values,
        questionnaire,
        idOperation,
        idOperationParent,
        onlyQuestions: false,
        SECTIONS,
        refQuestionnaireSent,
        useGetQuestionnaireAnswerRequest,
        useSaveQuestionnaireAnswerRequest,
        submitFunction,
      });
    }

  }).catch((error) => {
    onValidationError({
      error,
      mc,
      formikRef,
      questionnaire,
    })
  })
}

function buildValidation({
  values,
  questionnaire,
  idOperation,
  idOperationParent,
  SECTIONS,
  refQuestionnaireSent,
}) {
  const validationSchema = {};

  const validationQuestionnaire = handleQuestionnaireAnswerToSave({
    values,
    questionnaire,
    onlyQuestions: true,
    SECTIONS,
  });

  let allQuestions = [...validationQuestionnaire];
  for (const question of allQuestions) {
    if (question.childrenQuestions?.length) allQuestions = [...allQuestions, ...question.childrenQuestions]
  }

  for (const question of allQuestions) {
    if (!question?.key) continue;

    question?.childrenQuestions?.map(item => {
      if (item.visibleQuestion && item.fieldMask?.type == 'phone' && item.behaviorObject?.isRequired) {
        validationSchema[item.key] = yup.string().test({
          name: "answer-validation",
          message: "Invalid phone",
          test: (value) => !!value && value.length >= 10
        })
      } else if (item.visibleQuestion && item.behaviorObject?.fieldMask == 'email') {
        if (item.answer) {
          validationSchema[item.key] = yup.string().email('Invalid email').required("Required field")
        } else {
          if (item.behaviorObject?.isRequired) {
            validationSchema[item.key] = yup.string().email("Invalid email").required("Required field")
          } else {
            validationSchema[item.key] = yup.string().notRequired();
          }
        }
      } else {
        validationSchema[item.key] = item.visibleQuestion && item.behaviorObject?.isRequired
          ? yup.string().test("answer-validation", "Required field", function (value) {
            return !!item.answer;
          }) : yup.string().notRequired();
      }
    })

    if (question.visibleQuestion && question.behaviorObject?.isRequired && question.fieldMask?.type == 'phone') {
      validationSchema[question.key] = yup.string().test({
        name: "answer-validation",
        message: "Invalid phone",
        test: (value) => !!value && value.length >= 10
      })
    } else if (question.visibleQuestion && question.behaviorObject?.fieldMask == 'email') {
      if (question.answer) {
        validationSchema[question.key] = yup.string().email("Invalid email").required("Required field")
      } else {
        if (question.behaviorObject?.isRequired) {
          validationSchema[question.key] = yup.string().email("Invalid email").required("Required field")
        } else {
          validationSchema[question.key] = yup.string().notRequired();
        }
      }
    } else {
      validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
        ? yup.string().test("answer-validation", "Required field", function (value) {
          return !!question.answer;
        }) : yup.string().notRequired();
    }
  }

  return yup.object().shape(validationSchema);
}

function handleValidationsSubmittedForm({
  values,
  questionnaire,
  setFieldError,
  SECTIONS,
  mc,
}) {
  let validationResult = true;

  return validationResult;
}

function onValidationError({
  error,
  mc,
  formikRef,
  questionnaire,
}) {
  console.log('onValidationError catch initial', error)

  questionnaire = cloneDeep(questionnaire);

  mc.error('Please complete all required fields to proceed.')
  const allQuestions = questionnaire;

  let firstErrorKey = null;
  try {
    for (const question of allQuestions) {
      if (!formikRef.current.errors || !formikRef.current.errors[question.key]) continue;
      formikRef.current.setFieldError(question.key, null);
    }

    error.inner.map(({ message, path }) => {
      const question = allQuestions.find(question => question.key === path);

      if (question.dsQuestion === "E-mail") {
        mc.error(`The email entered is invalid`);
        formikRef.current.setFieldError(question.key, `* Invalid email`);
      } else {
        mc.error(`The Field: ${question.dsQuestion} is required`);
        formikRef.current.setFieldError(question.key, `* Required field`);
      }

      if (!firstErrorKey) firstErrorKey = question.key;
    });

    if (firstErrorKey) {
      const elements = global.window.document.getElementsByName(firstErrorKey);
      if (elements?.length) {
        setTimeout(() => elements[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' }), 300);
      }
    }
  } catch (e) {
    console.log('onValidationError catch', e)
  }
}

function handleQuestionnaireAnswerToSave({
  values,
  questionnaire,
  onlyQuestions,
  SECTIONS,
}) {
  const formValues = JSON.parse(JSON.stringify(values)) || {};
  
  let questionnaireAnswers = []

  for (const [index, section] of Object.entries(SECTIONS)) {
    if (section.isMultiple) {
      let multipleFields = []
      switch (section.name) {
        default:
          multipleFields = [];
          break;
        }
        
        multipleFields.map((field, index) => {
          let sectionAnswers = formValues[`$ANSWERS_${section.name}_${index}`];
        if (sectionAnswers?.length) {
          const rootQuestion = sectionAnswers.find((question) => !question.idQuestionRoot);
          const childrenQuestions = sectionAnswers.filter((question) => question.idQuestionRoot);
          rootQuestion.childrenQuestions = childrenQuestions;
          if (!onlyQuestions) {
            questionnaireAnswers = [...questionnaireAnswers, rootQuestion];
          } else {
            questionnaireAnswers = [...questionnaireAnswers, ...sectionAnswers];
          }
        }
      });
    } else {
      let sectionAnswers = formValues[`$ANSWERS_${section.name}`];
      if (sectionAnswers) {
        questionnaireAnswers = [...questionnaireAnswers, ...sectionAnswers];
      }
    }
  }
  
  let childrenQuestionIds = [];
  for (const question of questionnaireAnswers) {
    if (question) {
      if (
        (question.idDomainQuestion === 270 ||
          question.idDomainQuestion === 271 ||
          (question.idDomainQuestion === 44 && typeof question.answer === 'object')
        ) && question.answer
      ) {
        try {
          question.answer = JSON.stringify(question.answer)
        } catch (e) {
        }
      }
      
      if(question.idQuestion === 2207 && question.answer === '[]' ) {
        question.answer = null
      } else {
      }
      if (SECTIONS[question.behaviorObject?.sectionName] && SECTIONS[question.behaviorObject?.sectionName].isMultiple) {
        if (question?.childrenQuestions?.length) {
          const idQuestions = question.childrenQuestions.map(question => question.idQuestion);
          childrenQuestionIds = [...childrenQuestionIds, ...idQuestions];
        }
      } else {
        question.childrenQuestions = [];
      }

    }
  }

  questionnaireAnswers = questionnaireAnswers.filter(v => !childrenQuestionIds.includes(v.idQuestion))

  return questionnaireAnswers;
}

function handleSubmit({
  values,
  questionnaire,
  idOperation,
  idOperationParent,
  onlyQuestions,
  SECTIONS,
  refQuestionnaireSent,
  useGetQuestionnaireAnswerRequest,
  useSaveQuestionnaireAnswerRequest,
  submitFunction
}) {

  if (refQuestionnaireSent.current) return;

  refQuestionnaireSent.current = true;

  const validQuestionnaire = handleQuestionnaireAnswerToSave({
    values,
    questionnaire,
    onlyQuestions,
    SECTIONS,
  });

  useSaveQuestionnaireAnswerRequest(validQuestionnaire)
  .then((resp) => {
      if (resp.status === 200) {
        useGetQuestionnaireAnswerRequest();
        if (submitFunction) {
          submitFunction();
        } else {
          window.location.reload();
        }
      }
    })
    .catch((e) => {
      console.log('handleSubmit - error', e)
    })
    .finally(() => {
      refQuestionnaireSent.current = false;
    });
}


const events = {
  handleInitialAdjustments,
  handleSave,
};

export { events };
